import React, { useRef } from 'react';
import * as Icon from 'react-feather';
import { Toast } from 'primereact/toast';

interface PinModalProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  pinCode: string;
  proposalId: string;
}

const PinModal: React.FC<PinModalProps> = ({
  isOpen,
  setIsOpen,
  pinCode,
  proposalId,
}) => {
  const toast = useRef<Toast>(null);
  const proposalLink = `https://www.emranventures.com/proposals/${proposalId}`;

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Copied to clipboard',
        life: 2000,
      });
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <div
        className={`modal fade ${isOpen ? 'show' : ''}`}
        id="pin-modal"
        style={{ display: isOpen ? 'block' : 'none', zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Proposal Access Information</h5>
              <button
                type="button"
                className="btn-close close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsOpen(false)}
              >
                <Icon.X className="react-feather-custom"></Icon.X>
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-4">
                <h6>PIN Code</h6>
                <div className="d-flex align-items-center">
                  <div className="form-control bg-light">{pinCode}</div>
                  <button
                    className="btn btn-outline-primary ms-2"
                    onClick={() => copyToClipboard(pinCode)}
                  >
                    <Icon.Copy size={16} />
                  </button>
                </div>
              </div>

              <div>
                <h6>Proposal Link</h6>
                <div className="d-flex align-items-center">
                  <div className="form-control bg-light text-truncate">
                    {proposalLink}
                  </div>
                  <button
                    className="btn btn-outline-primary ms-2"
                    onClick={() => copyToClipboard(proposalLink)}
                  >
                    <Icon.Copy size={16} />
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setIsOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PinModal; 